import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

import Breadcrumbs from '@/atoms/Breadcrumb'
import PRODUCT_AS_FANSI_KIND from '@/constants/productAsFansiKind'
import useProducts from '@/hooks/useProducts'
import CreatorSlider from '@/organisms/CreatorSlider'
import PageHero from '@/organisms/PageHero'
import ProductsGrid from '@/organisms/ProductsGrid/ProductsGrid'
import GTM from '@/services/GTM'
import Creator from '@/ts/Creator'
import ProductType from '@/ts/enums/product/ProductType'
import { FansiKind } from '@/ts/Global'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import Product from '@/ts/Product'
import Presentation from '@/views/common/Presentation'

function ProductsView({
  creators,
  filters,
  productType,
  fansiKind,
}: ProductsViewProps) {
  const { t } = useTranslation('global')

  const data = useProducts(productType)
  const { products, count, maxPrice, isLoading } = data
  const withoutSort = fansiKind === 'fansi_experience'
  const noResults = !isLoading && count <= 0
  const shouldDisplayContent = count > 0 && products.length > 0

  useEffect(() => {
    if (products.length > 0) {
      GTM.pushCategory(products, fansiKind)
    }
  }, [products.length])

  return (
    <div>
      <Breadcrumbs
        crumbs={[{ label: `${t(PRODUCT_AS_FANSI_KIND[productType])}` }]}
        className="mb-8"
      />
      <div className="space-y-10 md:space-y-20">
        <PageHero kind={fansiKind} />
        <div className="space-y-6 md:space-y-8">
          <CreatorSlider creators={creators} />
        </div>
        <Presentation
          withoutSort={withoutSort}
          title="all_products"
          totalItems={count}
          noResults={noResults}
          filters={filters}
          maxPrice={maxPrice}
          shouldDisplayContent={shouldDisplayContent}
        >
          <ProductsGrid products={products} />
        </Presentation>
      </div>
    </div>
  )
}

interface ProductsViewProps {
  filters?: FilterGroup
  bestsellers?: Product[]
  creators?: Creator[]
  upcoming?: Product[]
  productType: ProductType
  fansiKind: FansiKind
}

export default ProductsView
